/* eslint-disable quotes */
// components.application.rewards.redeem.viewReward.faq

export const REWARD_FAQ = {};
